import { useTranslation } from 'react-i18next'

import { getLayoutErrorsDescriptionKey } from '../helpers'
import BlockErrorsRow from './BlockErrorsRow/BlockErrorsRow'
import * as Styles from './styles'

const LayoutErrorsTooltip = ({ rows, onNavigateToBlock }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Styles.Description type="bodySRegular">
        {t(getLayoutErrorsDescriptionKey(rows.length), { count: rows.length })}
      </Styles.Description>
      <Styles.Rows>
        {rows.map(row => (
          <BlockErrorsRow
            key={row.blockId}
            name={row.name}
            errorCount={row.errorCount}
            onNavigate={() => onNavigateToBlock(row.blockId)}
          />
        ))}
      </Styles.Rows>
    </Styles.Container>
  )
}

export default LayoutErrorsTooltip
